// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgTrees2 = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.5a4.5 4.5 0 0 0-.75 8.938V9.316l-1.024-1a.75.75 0 1 1 1.048-1.073l.72.703.726-.726a.75.75 0 0 1 1.06 1.06l-1.03 1.03v3.128A4.501 4.501 0 0 0 10 3.5Zm.75 10.454a6.001 6.001 0 1 0-1.5 0v3.296a.75.75 0 0 0 1.5 0v-3.296Z"
    />
  </svg>
)

export default SvgTrees2
